/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Pit2_TInputs */

const en_diff_pit2_t = /** @type {(inputs: Diff_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A type change is reported as a single change, not a removal plus an addition`)
};

const ko_diff_pit2_t = /** @type {(inputs: Diff_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`타입 변경은 제거와 추가가 아니라 하나의 변경으로 보고됩니다`)
};

const ja_diff_pit2_t = /** @type {(inputs: Diff_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`型の変更は削除と追加ではなく 1 件の変更として報告されます`)
};

/**
* | output |
* | --- |
* | "A type change is reported as a single change, not a removal plus an addition" |
*
* @param {Diff_Pit2_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_pit2_t = /** @type {((inputs?: Diff_Pit2_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Pit2_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_pit2_t(inputs)
	if (locale === "ko") return ko_diff_pit2_t(inputs)
	return ja_diff_pit2_t(inputs)
});